import { useCallback } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import * as settingsStyles from '../Settings/styles/payment-settings-page.styles';

const styles = {
  content: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${theme.spacing(2)};
  `,
};

const DEMO_PAYMENTS_URL = 'https://www.getweave.com/demo/campaign/xp/payments/';

export const SurchargeSettingsNoPayments = ({ disabled = false }: { disabled?: boolean } = {}) => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });

  const onClickGetStarted = useCallback(() => {
    window.open(DEMO_PAYMENTS_URL, '_blank');
  }, []);

  return (
    <div data-testid='surcharge-settings-no-payments'>
      <Heading css={settingsStyles.sectionHeading} level={3}>
        {t('Surcharging')}
      </Heading>

      <div css={styles.content}>
        <div>
          <Text color={disabled ? 'disabled' : 'default'}>{t('Sign up for terminals to utilize surcharging')}</Text>
        </div>
        <div>
          <Button trackingId='surcharge--no-payments--get-started' onClick={onClickGetStarted} disabled={disabled}>
            {t('Get Started')}
          </Button>
        </div>
      </div>
    </div>
  );
};
